var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9965,
    cy: 10.9965,
    r: 10.9965,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2332 12.525L8.17525 15.7358C8.06084 15.8559 7.91523 15.916 7.73841 15.916C7.56159 15.916 7.41597 15.8559 7.30156 15.7358C7.18715 15.6157 7.12994 15.4628 7.12994 15.2771C7.12994 15.0914 7.18715 14.9385 7.30156 14.8184L10.3595 11.6076L7.30156 8.39677C7.18715 8.27664 7.12994 8.12374 7.12994 7.93808C7.12994 7.75242 7.18715 7.59953 7.30156 7.47939C7.41597 7.35926 7.56159 7.29919 7.73841 7.29919C7.91523 7.29919 8.06084 7.35926 8.17525 7.47939L11.2332 10.6902L14.2911 7.47939C14.4055 7.35926 14.5511 7.29919 14.7279 7.29919C14.9048 7.29919 15.0504 7.35926 15.1648 7.47939C15.2792 7.59953 15.3364 7.75242 15.3364 7.93808C15.3364 8.12374 15.2792 8.27664 15.1648 8.39677L12.1069 11.6076L15.1648 14.8184C15.2792 14.9385 15.3364 15.0914 15.3364 15.2771C15.3364 15.4628 15.2792 15.6157 15.1648 15.7358C15.0504 15.8559 14.9048 15.916 14.7279 15.916C14.5511 15.916 14.4055 15.8559 14.2911 15.7358L11.2332 12.525Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCheck);
export default __webpack_public_path__ + "static/media/noCheck.bfb83319da26cf25b7eb14ef35e04f84.svg";
export { ForwardRef as ReactComponent };